export function trigger() {
  const navTrigger = document.querySelector('.trigger-nav');
  const header = document.querySelector('.header');
  const footer = document.querySelector('.footer');

  let savedScrollY = 0; // ナビを開く直前のスクロール位置（閉じたとき復元する）。

  // ナビを開く：container が消えて footer だけになるので、
  // footer の一番上が画面先頭に来るようスクロールする。
  const openNav = () => {
    savedScrollY = window.scrollY;
    document.body.classList.remove('is-search-active');
    document.body.classList.add('is-nav-active');
    // クラス付与で .container が display:none になる。getBoundingClientRect() が
    // レイアウトを同期確定させるため、ここで測れば消えた後の footer 位置が取れる。
    // （rect.top + scrollY はスクロールがクランプされても footer の絶対位置で不変）
    if (footer) {
      // footer の rowm-4（上マージン）ぶんも画面に入るよう、マージン上端まで戻す。
      const marginTop = parseFloat(getComputedStyle(footer).marginTop) || 0;
      const top = footer.getBoundingClientRect().top + window.scrollY - marginTop;
      window.scrollTo(0, Math.max(0, top));
    } else {
      window.scrollTo(0, 0);
    }
  };

  // ナビを閉じる：container が戻ってから、開く前のスクロール位置へ復元する。
  const closeNav = () => {
    if (!document.body.classList.contains('is-nav-active')) return;
    document.body.classList.remove('is-nav-active');
    void document.body.offsetHeight; // 強制リフロー（ページ高さを戻してから scroll）
    window.scrollTo(0, savedScrollY);
  };

  if (navTrigger) {
    navTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (document.body.classList.contains('is-nav-active')) {
        closeNav();
      } else {
        openNav();
      }
    })
  }

  const handleReset = () => {
    closeNav();
    if(header) header.style.height = '';
  }
  const navReset = document.querySelector('.trigger-reset');
  if (navReset) {
    navReset.addEventListener('click', (e) => {
      e.preventDefault();
      handleReset();
    })
  }

  let lastInnerWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    if (lastInnerWidth !== window.innerWidth) {
      lastInnerWidth = window.innerWidth;
      handleReset();
    }
  });
}
